<template>
  <div
    class="relative flex items-start min-h-screen w-full max-w-full overflow-x-clip bg-slate-50 dark:bg-slate-900"
  >
    <!-- Sidebar -->
    <AdminSidebar
      :is-collapsed="isSidebarCollapsed"
      :is-open-mobile="isSidebarOpenMobile"
      :sidebar-search="sidebarSearch"
      :lang="lang"
      :t="t"
      @update:sidebar-search="sidebarSearch = $event"
    />


    <!-- Main content -->
    <div class="flex flex-col flex-1 min-w-0 w-full">
      <!-- Top bar -->
      <AdminTopbar
        :is-collapsed="isSidebarCollapsed"
        :lang="lang"
        :t="t"
        @toggle-sidebar="toggleSidebar"
      />

      <!-- Content area -->
      <main class="flex-1 px-4 py-6 md:px-6 lg:px-8">
        <div class="max-w-6xl mx-auto">
          <!-- Page header -->
          <div
            class="flex flex-col justify-between gap-3 mb-4 sm:flex-row sm:items-center"
          >
            <div>
              <h1 class="text-lg font-semibold text-slate-900 dark:text-white">
                {{ t("consult_create_title") }}
              </h1>
              <p class="text-sm text-slate-500 dark:text-slate-400">
                {{ t("consult_create_subtitle") }}
              </p>
            </div>
          </div>

          <!-- Card wrapper -->
          <section
            class="overflow-hidden bg-white border shadow-sm dark:bg-slate-900 border-slate-200 dark:border-slate-700 rounded-2xl"
          >
            <!-- Inner card header -->
            <header
              class="px-5 py-3 text-sm font-medium border-b bg-slate-50/90 dark:bg-slate-800/80 border-slate-100 dark:border-slate-800"
            >
              {{ t("consult_create_title") }}
            </header>

            <!-- FORM BODY -->
            <form class="space-y-6" @submit.prevent="submitForm(2)">
              <!-- Consultation main info -->
              <section class="px-5 pt-4 space-y-4">
                <!-- Subject -->
                <div>
                  <label
                    class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                  >
                    {{ t("consult_field_subject") }}
                    <span class="text-rose-500">*</span>
                  </label>
                  <div class="relative">
                    <span
                      class="absolute inset-y-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                      :class="
                        lang === 'ar'
                          ? 'right-0 rounded-r-md'
                          : 'left-0 rounded-l-md'
                      "
                    >
                      <i class="mdi mdi-form-textbox text-[18px]"></i>
                    </span>
                    <input
                      v-model="form.subject"
                      type="text"
                      class="w-full py-2 text-sm border rounded-lg bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                      :class="lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'"
                      :placeholder="t('consult_field_subject_placeholder')"
                      required
                    />
                  </div>
                </div>

                <!-- Description -->
                <div>
                  <label
                    class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                  >
                    {{ t("consult_field_description") }}
                  </label>
                  <textarea
                    v-model="form.description"
                    rows="4"
                    class="w-full px-3 py-2 text-sm border rounded-lg bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                    :placeholder="t('consult_field_description_placeholder')"
                  ></textarea>
                </div>

                <!-- Activity + Type -->
                <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                  <!-- Activity -->
                  <!--  <div>
                    <label
                      class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                    >
                      {{ t("consult_field_activity") }}
                      <span class="text-rose-500">*</span>
                    </label>
                    <div class="relative">
                      <span
                        class="absolute inset-y-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                        :class="
                          lang === 'ar'
                            ? 'right-0 rounded-r-md'
                            : 'left-0 rounded-l-md'
                        "
                      >
                        <i class="mdi mdi-view-grid-outline text-[18px]"></i>
                      </span>-->

                  <!-- ✅ dynamic from store -->
                  <!-- <select
                        v-model.number="form.activity_id"
                        class="w-full py-2 text-sm border rounded-lg bg-slate-50 dark:bg-slate-800 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                        :class="lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'"
                        required
                      >
                        <option :value="null">
                          {{ t("consult_field_activity_placeholder") }}
                        </option>
                        <option value="1">{{ t("Construction") }}</option>
                      </select>-->
                  <!-- </div>
                  </div>-->

                  <!-- Type -->
                  <div>
                    <label
                      class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                    >
                      {{ t("consult_field_type") }}
                    </label>
                    <SearchableSelect
                      v-model="typeIdModel"
                      :options="typeSelectOptions"
                      :lang="lang"
                      block
                      min-width="100%"
                      max-width="none"
                      menu-min-width="18rem"
                      menu-max-width="26rem"
                      :placeholder="t('consult_field_type_placeholder')"
                      :search-placeholder="t('consult_filter_type_search')"
                      :empty-label="t('consult_filter_type_empty')"
                      :searchable="true"
                    />
                  </div>
                </div>
              </section>

              <!-- Attachments -->
              <section>
                <div
                  class="flex items-center gap-2 px-5 py-2.5 text-sm font-medium border-y bg-slate-50/90 dark:bg-slate-800/80 border-slate-100 dark:border-slate-800"
                >
                  <i class="mdi mdi-paperclip text-secondary"></i>
                  <span>{{ t("consult_section_attachments") }}</span>
                  <span class="text-xs text-slate-400">
                    {{ t("consult_section_attachments_optional") }}
                  </span>
                </div>

                <div class="px-5 py-4">
                  <label
                    class="flex flex-col items-center justify-center w-full px-4 py-6 text-sm transition border-2 border-dashed cursor-pointer rounded-xl border-slate-200 dark:border-slate-700 bg-slate-50/60 dark:bg-slate-900/40 hover:border-primary/60 hover:bg-primary/5"
                  >
                    <!-- ✅ إذا فيه ملفات مختارة -->
                    <template v-if="attachments.length">
                      <i
                        class="mb-2 text-2xl mdi mdi-check-circle-outline text-emerald-600"
                      ></i>

                      <span
                        class="mb-1 font-medium text-slate-700 dark:text-slate-200"
                      >
                        {{ attachments.length }}
                        {{ t("files_selected") || "files selected" }}
                      </span>

                      <div
                        class="grid w-full grid-cols-1 gap-2 mt-3 sm:grid-cols-4"
                      >
                        <div
                          v-for="(f, i) in attachments"
                          :key="'file-box-' + i"
                          class="flex items-center gap-3 p-3 border rounded-xl bg-white/80 dark:bg-slate-800/70 border-slate-200 dark:border-slate-700"
                          :title="f.name"
                        >
                          <div
                            class="flex items-center justify-center rounded-lg w-9 h-9 bg-primary/10 text-primary"
                          >
                            <i class="mdi mdi-file-outline text-[20px]"></i>
                          </div>

                          <div class="flex-1 min-w-0 text-left">
                            <div
                              class="text-xs font-medium truncate text-slate-800 dark:text-slate-100"
                            >
                              {{ f.name }}
                            </div>
                            <div
                              class="text-[11px] text-slate-500 dark:text-slate-400"
                            >
                              {{ (f.size / 1024 / 1024).toFixed(2) }} MB
                            </div>
                          </div>
                        </div>
                      </div>

                      <span class="mt-2 text-xs text-slate-400">
                        {{
                          t("click_to_change_files") || "Click to change files"
                        }}
                      </span>
                    </template>

                    <!-- ✅ إذا ما فيه ملفات -->
                    <template v-else>
                      <i
                        class="mb-2 text-2xl mdi mdi-cloud-upload-outline text-secondary"
                      ></i>
                      <span class="mb-1 text-slate-700 dark:text-slate-200">
                        {{ t("consult_attachments_label") }}
                      </span>
                      <span class="text-xs text-slate-400">
                        {{ t("consult_attachments_hint") }}
                      </span>
                    </template>

                    <input
                      :key="attachmentsKey"
                      type="file"
                      class="hidden"
                      multiple
                      @change="handleFiles"
                    />
                  </label>
                </div>
              </section>

              <!-- Contact Methods -->
              <section class="pb-4">
                <div
                  class="flex items-center gap-2 px-5 py-2.5 text-sm font-medium border-y bg-slate-50/90 dark:bg-slate-800/80 border-slate-100 dark:border-slate-800"
                >
                  <i class="mdi mdi-account-voice text-secondary"></i>
                  <span>{{ t("consult_section_contact_methods") }}</span>
                </div>

                <div class="px-5 py-4">
                  <div class="grid grid-cols-1 gap-4 md:grid-cols-3">
                    <!-- None -->
                    <div
                      class="flex flex-col h-full p-4 transition border cursor-pointer rounded-2xl bg-slate-50/70 dark:bg-slate-900/40 border-slate-200 dark:border-slate-700"
                      :class="
                        form.oppointment_method === 'none'
                          ? 'ring-2 ring-primary/60 bg-primary/5'
                          : 'hover:border-primary/50'
                      "
                      @click="selectMethod('none')"
                    >
                      <div class="flex items-center justify-between mb-3">
                        <div class="flex items-center gap-3">
                          <div
                            class="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10"
                          >
                            <i
                              class="text-xl mdi mdi-close-circle-outline text-primary"
                            ></i>
                          </div>
                          <div>
                            <h3
                              class="text-sm font-semibold text-slate-800 dark:text-slate-100"
                            >
                              {{ t("consult_method_none_title") }}
                            </h3>
                            <p
                              class="text-xs text-slate-500 dark:text-slate-400"
                            >
                              {{ t("consult_method_none_desc") }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="mt-auto">
                        <button
                          type="button"
                          class="w-full px-3 py-2 text-xs font-medium border rounded-lg"
                          :class="
                            form.oppointment_method === 'none'
                              ? 'bg-primary text-white border-primary'
                              : 'bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                          "
                        >
                          {{ t("consult_method_select") }}
                          <span
                            v-if="form.oppointment_method === 'none'"
                            class="inline-block ml-1 text-[10px]"
                            >✓</span
                          >
                        </button>
                      </div>
                    </div>

                    <!-- Instant Chat -->
                    <div
                      class="flex flex-col h-full p-4 transition border cursor-pointer rounded-2xl bg-slate-50/70 dark:bg-slate-900/40 border-slate-200 dark:border-slate-700"
                      :class="
                        form.oppointment_method === 'chat'
                          ? 'ring-2 ring-primary/60 bg-primary/5'
                          : 'hover:border-primary/50'
                      "
                      @click="selectMethod('chat')"
                    >
                      <div class="flex items-center justify-between mb-3">
                        <div class="flex items-center gap-3">
                          <div
                            class="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10"
                          >
                            <i
                              class="text-xl mdi mdi-message-text-outline text-primary"
                            ></i>
                          </div>
                          <div>
                            <h3
                              class="text-sm font-semibold text-slate-800 dark:text-slate-100"
                            >
                              {{ t("consult_method_chat_title") }}
                            </h3>
                            <p
                              class="text-xs text-slate-500 dark:text-slate-400"
                            >
                              {{ t("consult_method_chat_desc") }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="mt-auto">
                        <button
                          type="button"
                          class="w-full px-3 py-2 text-xs font-medium border rounded-lg"
                          :class="
                            form.oppointment_method === 'chat'
                              ? 'bg-primary text-white border-primary'
                              : 'bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                          "
                        >
                          {{ t("consult_method_select") }}
                          <span
                            v-if="form.oppointment_method === 'chat'"
                            class="inline-block ml-1 text-[10px]"
                            >✓</span
                          >
                        </button>
                      </div>
                    </div>

                    <!-- Video Call (session) -->
                    <div
                      class="flex flex-col h-full p-4 transition border cursor-pointer rounded-2xl bg-slate-50/70 dark:bg-slate-900/40 border-slate-200 dark:border-slate-700"
                      :class="
                        form.oppointment_method === 'session'
                          ? 'ring-2 ring-primary/60 bg-primary/5'
                          : 'hover:border-primary/50'
                      "
                      @click="selectMethod('session')"
                    >
                      <div class="flex items-center justify-between mb-3">
                        <div class="flex items-center gap-3">
                          <div
                            class="flex items-center justify-center w-10 h-10 rounded-full bg-primary/10"
                          >
                            <i
                              class="text-xl mdi mdi-video-outline text-primary"
                            ></i>
                          </div>
                          <div>
                            <h3
                              class="text-sm font-semibold text-slate-800 dark:text-slate-100"
                            >
                              {{ t("consult_method_video_title") }}
                            </h3>
                            <p
                              class="text-xs text-slate-500 dark:text-slate-400"
                            >
                              {{ t("consult_method_video_desc") }}
                            </p>
                          </div>
                        </div>
                      </div>

                      <div class="mt-auto">
                        <button
                          type="button"
                          class="w-full px-3 py-2 text-xs font-medium border rounded-lg"
                          :class="
                            form.oppointment_method === 'session'
                              ? 'bg-primary text-white border-primary'
                              : 'bg-white dark:bg-slate-900 text-slate-700 dark:text-slate-200 border-slate-200 dark:border-slate-700'
                          "
                        >
                          {{ t("consult_method_select") }}
                          <span
                            v-if="form.oppointment_method === 'session'"
                            class="inline-block ml-1 text-[10px]"
                            >✓</span
                          >
                        </button>
                      </div>
                    </div>
                  </div>

                  <!-- DETAILS -->
                  <div
                    v-if="form.oppointment_method !== 'none'"
                    class="mt-6 overflow-hidden border rounded-2xl border-slate-200 dark:border-slate-700 bg-slate-50/70 dark:bg-slate-900/40"
                  >
                    <!-- Chat details -->
                    <div v-if="form.oppointment_method === 'chat'">
                      <div
                        class="flex items-center gap-2 px-4 py-2 text-sm font-medium border-b border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-900/60"
                      >
                        <i
                          class="mdi mdi-message-text-outline text-secondary"
                        ></i>
                        <span>{{ t("consult_method_chat_title") }}</span>
                      </div>

                      <div class="px-4 py-4 space-y-4">
                        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                          <!-- Appointment Date -->
                          <div>
                            <label
                              class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                            >
                              {{ t("consult_chat_date") }}
                              <span class="text-rose-500">*</span>
                            </label>
                            <div class="relative">
                              <span
                                class="absolute inset-y-0 right-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                                :class="
                                  lang === 'ar'
                                    ? 'right-0 rounded-r-md'
                                    : 'left-0 rounded-l-md'
                                "
                              >
                                <i
                                  class="mdi mdi-calendar-blank-outline text-[18px]"
                                ></i>
                              </span>
                              <input
                                v-model="chat.date"
                                type="date"
                                class="w-full py-2 text-sm bg-white border rounded-lg dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                :class="
                                  lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'
                                "
                              />
                            </div>
                          </div>

                          <!-- Time -->
                          <div>
                            <label
                              class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                            >
                              {{ t("consult_chat_time") }}
                              <span class="text-rose-500">*</span>
                            </label>
                            <div class="relative">
                              <span
                                class="absolute inset-y-0 right-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                                :class="
                                  lang === 'ar'
                                    ? 'right-0 rounded-r-md'
                                    : 'left-0 rounded-l-md'
                                "
                              >
                                <i
                                  class="mdi mdi-clock-outline text-[18px]"
                                ></i>
                              </span>
                              <input
                                v-model="chat.time"
                                type="time"
                                class="w-full py-2 text-sm bg-white border rounded-lg dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                :class="
                                  lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'
                                "
                              />
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>

                    <!-- Session details -->
                    <div v-else-if="form.oppointment_method === 'session'">
                      <div
                        class="flex items-center gap-2 px-4 py-2 text-sm font-medium border-b border-slate-200 dark:border-slate-700 bg-white/70 dark:bg-slate-900/60"
                      >
                        <i class="mdi mdi-video-outline text-secondary"></i>
                        <span>{{ t("consult_method_video_title") }}</span>
                      </div>

                      <div class="px-4 py-4 space-y-4">
                        <div class="grid grid-cols-1 gap-4 md:grid-cols-2">
                          <!-- Appointment Date -->
                          <div>
                            <label
                              class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                            >
                              {{ t("consult_video_date") }}
                              <span class="text-rose-500">*</span>
                            </label>
                            <div class="relative">
                              <span
                                class="absolute inset-y-0 right-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                                :class="
                                  lang === 'ar'
                                    ? 'right-0 rounded-r-md'
                                    : 'left-0 rounded-l-md'
                                "
                              >
                                <i
                                  class="mdi mdi-calendar-blank-outline text-[18px]"
                                ></i>
                              </span>
                              <input
                                v-model="video.date"
                                type="date"
                                class="w-full py-2 text-sm bg-white border rounded-lg dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                :class="
                                  lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'
                                "
                              />
                            </div>
                          </div>

                          <!-- Time -->
                          <div>
                            <label
                              class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                            >
                              {{ t("consult_video_time") }}
                              <span class="text-rose-500">*</span>
                            </label>
                            <div class="relative">
                              <span
                                class="absolute inset-y-0 right-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                                :class="
                                  lang === 'ar'
                                    ? 'right-0 rounded-r-md'
                                    : 'left-0 rounded-l-md'
                                "
                              >
                                <i
                                  class="mdi mdi-clock-outline text-[18px]"
                                ></i>
                              </span>
                              <input
                                v-model="video.time"
                                type="time"
                                class="w-full py-2 text-sm bg-white border rounded-lg dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                                :class="
                                  lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'
                                "
                              />
                            </div>
                          </div>
                        </div>

                        <!-- Session URL -->
                        <div>
                          <label
                            class="block mb-1 text-xs font-medium text-slate-600 dark:text-slate-300"
                          >
                            {{ t("consult_video_url") }}
                            <span class="text-rose-500">*</span>
                          </label>
                          <div class="relative">
                            <span
                              class="absolute inset-y-0 right-0 flex items-center justify-center w-8 bg-secondary/15 text-primary"
                              :class="
                                lang === 'ar'
                                  ? 'right-0 rounded-r-md'
                                  : 'left-0 rounded-l-md'
                              "
                            >
                              <i class="mdi mdi-link-variant text-[18px]"></i>
                            </span>
                            <input
                              v-model="video.url"
                              type="url"
                              class="w-full py-2 text-sm bg-white border rounded-lg dark:bg-slate-900 border-slate-200 dark:border-slate-700 text-slate-800 dark:text-slate-100 focus:outline-none focus:ring-2 focus:ring-primary/40"
                              :class="lang === 'ar' ? 'pr-9 pl-3' : 'pl-9 pr-3'"
                              :placeholder="t('consult_video_url_placeholder')"
                            />
                          </div>
                        </div>
                      </div>
                    </div>
                  </div>
                  <!-- /DETAILS -->
                </div>
              </section>

              <!-- Actions -->
              <footer
                class="flex flex-col items-stretch gap-3 px-5 py-4 border-t border-slate-100 sm:flex-row sm:items-center sm:justify-between dark:border-slate-800 bg-slate-50/60 dark:bg-slate-900/60"
              >
                <div class="flex flex-wrap gap-2">
                  <!-- Save Draft -->
                  <button
                    type="button"
                    @click="submitForm(1)"
                    :disabled="savingDraft || submitting"
                    class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium border rounded-lg border-slate-200 text-slate-600 bg-slate-100/70 dark:bg-slate-800/70 dark:border-slate-700 dark:text-slate-200 disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    {{
                      savingDraft ? t("loading") : t("consult_btn_save_draft")
                    }}
                  </button>

                  <!-- Create -->
                  <button
                    type="submit"
                    :disabled="submitting || !isValid"
                    class="inline-flex items-center justify-center px-5 py-2 text-sm font-medium text-white rounded-lg shadow-sm bg-primary hover:bg-primary/90 disabled:opacity-60 disabled:cursor-not-allowed"
                  >
                    <i
                      class="mdi mdi-send text-[16px]"
                      :class="lang === 'ar' ? 'ml-1' : 'mr-1'"
                    ></i>
                    {{
                      submitting
                        ? t("publish") || "publish..."
                        : t("publish") || "publish"
                    }}
                  </button>

                  <!-- Clear -->
                  <button
                    type="button"
                    @click="resetForm"
                    class="inline-flex items-center justify-center px-4 py-2 text-sm font-medium bg-transparent border border-transparent rounded-lg text-slate-500 hover:text-slate-700 dark:text-slate-300 dark:hover:text-white"
                  >
                    {{ t("consult_btn_clear") }}
                  </button>
                </div>

                <p class="text-[11px] text-slate-400">
                  {{ t("consult_required_note") }}
                </p>
              </footer>
            </form>
          </section>

          <!-- ✅ simple toast (optional) -->
          <transition name="fade">
            <div
              v-if="toast.show"
              class="fixed z-50 px-4 py-3 text-sm text-white shadow-lg bottom-6 right-6 rounded-xl"
              :class="toast.type === 'error' ? 'bg-rose-600' : 'bg-emerald-600'"
            >
              {{ toast.message }}
            </div>
          </transition>
        </div>
      </main>
    </div>
  </div>
</template>

<script setup>
import { ref, computed, onMounted, onBeforeUnmount, watch } from "vue";
import { useRouter } from "vue-router";

import { messages } from "@/i18n";
import AdminSidebar from "@/components/Auth/Sidebar.vue";
import AdminTopbar from "@/components/Auth/TopNav.vue";
import api from "@/services/api";

import { useFeedStore } from "@/stores/feedStore";
import SearchableSelect from "@/components/SearchableSelect.vue";

// -------------------- lang --------------------
const initialLang = (
  document.documentElement.lang ||
  localStorage.getItem("app_lang") ||
  "ar"
).toLowerCase();

const lang = ref(initialLang.startsWith("ar") ? "ar" : "en");

const _langObserver = ref(null);
const _langHandler = ref(null);

// i18n helper
const t = (key) => (messages?.[lang.value] && messages[lang.value][key]) || key;

// -------------------- UI state --------------------
const isSidebarCollapsed = ref(false);
const isSidebarOpenMobile = ref(false);
const sidebarSearch = ref("");

// -------------------- API --------------------
const API_SAVE = "/consultations";

// -------------------- toast --------------------
const toast = ref({ show: false, type: "success", message: "" });

function showToast(msg, type = "success") {
  toast.value = { show: true, type, message: msg };
  setTimeout(() => (toast.value.show = false), 2500);
}

// -------------------- attachments --------------------
const attachments = ref([]);
const attachmentsKey = ref(0);

function handleFiles(e) {
  attachments.value = Array.from(e.target.files || []);
}

// -------------------- form --------------------
const form = ref({
  subject: "",
  description: "",
  type_id: null,
  attachments: [],
  oppointment_method: "none",
  oppointment_date: null,
  oppointment_time: null,
  oppointment_url: "",
});

const chat = ref({ date: "", time: "" });
const video = ref({ date: "", time: "", url: "" });

function selectMethod(key) {
  form.value.oppointment_method = key;

  form.value.oppointment_date = null;
  form.value.oppointment_time = null;
  form.value.oppointment_url = "";

  chat.value = { date: "", time: "" };
  video.value = { date: "", time: "", url: "" };
}

// -------------------- store (feed) --------------------
const feedStore = useFeedStore();

const loadingOptions = computed(() => feedStore.loading);

// ✅ use from store
const consultationTypes = computed(() => feedStore.consultationTypes || []);

const typeSelectOptions = computed(() =>
  consultationTypes.value.map((tp) => ({
    value: Number(tp.id),
    label:
      getLocalized(tp?.name) ||
      getLocalized(tp?.title) ||
      tp?.key ||
      String(tp.id),
  })),
);

const typeIdModel = computed({
  get: () => form.value.type_id ?? "",
  set: (value) => {
    form.value.type_id =
      value === "" || value == null ? null : Number(value);
  },
});

// helper: localized {ar,en}
function getLocalized(obj) {
  if (!obj) return "";
  if (typeof obj === "string") return obj;
  return lang.value === "ar" ? obj.ar || "" : obj.en || obj.ar || "";
}

// -------------------- validation --------------------
const isValid = computed(() => {
  if (!form.value.subject?.trim()) return false;
  if (!form.value.type_id) return false;

  if (form.value.oppointment_method === "none") return true;

  const hasDateTime =
    !!form.value.oppointment_date && !!form.value.oppointment_time;

  if (form.value.oppointment_method === "chat") return hasDateTime;

  if (form.value.oppointment_method === "session")
    return hasDateTime && !!form.value.oppointment_url?.trim();

  return true;
});

// -------------------- sidebar toggle --------------------
function toggleSidebar() {
  if (window.innerWidth < 768)
    isSidebarOpenMobile.value = !isSidebarOpenMobile.value;
  else isSidebarCollapsed.value = !isSidebarCollapsed.value;
}

// -------------------- file helpers --------------------
function fileToBase64(file) {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(reader.result); // dataURL
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

async function filesToPayload(files) {
  const out = [];

  for (const f of files) {
    const dataUrl = await fileToBase64(f);
    const base64 = String(dataUrl).includes("base64,")
      ? String(dataUrl).split("base64,")[1]
      : String(dataUrl);

    out.push({
      base64,
      name: f.name,
      type: f.type || "application/octet-stream",
      size: f.size || 0,
    });
  }

  return out;
}

async function buildBody(statusId) {
  const attachmentsPayload = attachments.value.length
    ? await filesToPayload(attachments.value)
    : [];

  const body = {
    subject: form.value.subject?.trim() || "",
    description: form.value.description?.trim() || "",
    status_id: statusId,
    type_id: form.value.type_id,
    attachments: attachmentsPayload,
    oppointment_method: form.value.oppointment_method || "none",
  };

  if (
    body.oppointment_method === "chat" ||
    body.oppointment_method === "session"
  ) {
    body.oppointment_date = form.value.oppointment_date;
    body.oppointment_time = form.value.oppointment_time;
  }

  if (
    body.oppointment_method === "session" &&
    form.value.oppointment_url?.trim()
  ) {
    body.oppointment_url = form.value.oppointment_url.trim();
  }

  return body;
}

// -------------------- submit --------------------
const router = useRouter();
const submitting = ref(false);
const savingDraft = ref(false);

async function submitForm(statusId = 2) {
  if (!isValid.value) {
    const msg = !form.value.subject?.trim()
      ? t("consult_validation_subject_required")
      : !form.value.type_id
      ? t("consult_validation_type_required")
      : form.value.oppointment_method !== "none" && !form.value.oppointment_date
      ? t("consult_validation_date_required")
      : form.value.oppointment_method !== "none" && !form.value.oppointment_time
      ? t("consult_validation_time_required")
      : form.value.oppointment_method === "session" &&
        !form.value.oppointment_url?.trim()
      ? t("consult_validation_url_required")
      : t("please_check_required_fields");

    showToast(msg, "error");
    return;
  }

  statusId === 1 ? (savingDraft.value = true) : (submitting.value = true);

  try {
    const body = await buildBody(statusId);

    await api.post(API_SAVE, body, {
      headers: { Accept: "application/json" },
    });

    showToast(t("account_saved_success"), "success");

    // redirect after create/draft
    if (statusId === 2) {
      router.push({ name: "consultations.my", query: { toast: "created" } });
      return;
    }
    if (statusId === 1) {
      router.push({ name: "consultations.my", query: { toast: "saved" } });
      return;
    }

    resetForm();
  } catch (e) {
    const serverErrors = e?.response?.data?.errors || {};
    const errorList = Object.values(serverErrors)
      .flat()
      .filter(Boolean)
      .join("\n");
    showToast(errorList || "Failed to create consultation.", "error");
  } finally {
    submitting.value = false;
    savingDraft.value = false;
  }
}

function resetForm() {
  form.value.subject = "";
  form.value.description = "";
  form.value.type_id = null;

  form.value.oppointment_method = "none";
  form.value.oppointment_date = null;
  form.value.oppointment_time = null;
  form.value.oppointment_url = "";

  attachments.value = [];
  attachmentsKey.value++;

  chat.value = { date: "", time: "" };
  video.value = { date: "", time: "", url: "" };
}

// -------------------- sync watchers (same behavior) --------------------
watch(
  () => chat.value.date,
  (v) => {
    if (form.value.oppointment_method === "chat")
      form.value.oppointment_date = v || null;
  },
);

watch(
  () => chat.value.time,
  (v) => {
    if (form.value.oppointment_method === "chat")
      form.value.oppointment_time = v || null;
  },
);

watch(
  () => video.value.date,
  (v) => {
    if (form.value.oppointment_method === "session")
      form.value.oppointment_date = v || null;
  },
);

watch(
  () => video.value.time,
  (v) => {
    if (form.value.oppointment_method === "session")
      form.value.oppointment_time = v || null;
  },
);

watch(
  () => video.value.url,
  (v) => {
    if (form.value.oppointment_method === "session")
      form.value.oppointment_url = v || "";
  },
);

// -------------------- lifecycle --------------------
onMounted(async () => {
  // fetch from store once
  await feedStore.fetchFeedOnce();

  // lang sync (same logic, but no re-fetch needed because store keeps both ar/en)
  _langHandler.value = (e) => {
    const next = String(e.detail || "ar")
      .toLowerCase()
      .startsWith("en")
      ? "en"
      : "ar";
    if (next !== lang.value) lang.value = next;
  };
  window.addEventListener("app:lang", _langHandler.value, { passive: true });

  _langObserver.value = new MutationObserver(() => {
    const htmlLang = (
      document.documentElement.lang ||
      localStorage.getItem("app_lang") ||
      "ar"
    ).toLowerCase();

    const next = htmlLang.startsWith("en") ? "en" : "ar";
    if (next !== lang.value) lang.value = next;
  });

  _langObserver.value.observe(document.documentElement, {
    attributes: true,
    attributeFilter: ["lang", "dir"],
  });
});

onBeforeUnmount(() => {
  if (_langObserver.value) _langObserver.value.disconnect();
  if (_langHandler.value)
    window.removeEventListener("app:lang", _langHandler.value);
});
</script>
